import React from 'react';
import { Loader } from '@thd-olt-component-react/core-ui';

export const Spinner = () => {
  return (
    <div className="spinner" role="spinner">
      <Loader active />
    </div>
  );
};
